<!-- components/ScoreCell.vue -->
<!-- ปรับปรุง: รองรับทั้งเกณฑ์เดิม (OLD) และเกณฑ์ใหม่ ว19/2568 (NEW) -->
<template>
  <div class="score-cell">
    <!-- วันที่กำหนด -->
    <v-chip outlined small :color="hasScore ? 'success' : 'grey'" class="mb-1">
      <v-icon v-if="!hasScore" left x-small>mdi-calendar</v-icon>
      {{ targetDate | moment("D MMMM YYYY") }}
    </v-chip>

    <!-- ===== เกณฑ์ใหม่ (NEW): แสดง pass/fail แทนคะแนน ===== -->
    <div v-if="criteriaVersion === 'NEW'">
      <div v-if="passStatus === 'pass'" class="score-pass">
        <v-chip small color="success" dark>
          <v-icon small left>mdi-check-circle</v-icon> ผ่าน
        </v-chip>
      </div>
      <div v-else-if="passStatus === 'fail'" class="score-fail">
        <v-chip small color="error" dark>
          <v-icon small left>mdi-close-circle</v-icon> ไม่ผ่าน
        </v-chip>
      </div>
      <div v-else-if="hasFile" class="score-pending">
        <v-chip small color="warning" outlined>
          <v-icon small left>mdi-clock-outline</v-icon> รอตรวจ
        </v-chip>
      </div>
      <div v-else class="score-na">
        <span class="grey--text text--lighten-1">-</span>
      </div>

      <!-- แสดง label เกณฑ์ -->
      <div v-if="hasScore" class="criteria-label mt-1">
        <v-chip x-small outlined color="blue">NEW</v-chip>
      </div>
    </div>

    <!-- ===== เกณฑ์เดิม (OLD): แสดงคะแนนตัวเลข ===== -->
    <div v-else>
      <!-- สถานะ สอศ. ตรวจสอบ -->
      <div v-if="checkStatus === 'Pass'" class="score-pass">
        <v-icon small color="green">mdi-checkbox-marked-circle-outline</v-icon>
        {{ score }}
      </div>
      <div v-else-if="checkStatus === 'NotPass'" class="score-fail">
        <v-icon small color="red">mdi-close-circle</v-icon>
        {{ score }}
      </div>
      <div v-else class="score-pending">
        <span v-if="hasFile">{{ score }}</span>
        <span v-else class="grey--text text--lighten-1">-</span>
      </div>

      <!-- คะแนนรายด้าน (เฉพาะเกณฑ์เดิม) -->
      <div v-if="score > 0" class="score-detail">
        <span :class="scoreAClass">[1] {{ scoreA }}</span>
        <span class="mx-1">:</span>
        <span :class="scoreBClass">[2] {{ scoreB }}</span>
      </div>

      <!-- แสดง label เกณฑ์ (ถ้าต้องการแยกชัดเจน) -->
      <div v-if="hasScore && showLabel" class="criteria-label mt-1">
        <v-chip x-small outlined color="grey">OLD</v-chip>
        <span v-if="passStatus === 'pending'" class="orange--text text-caption ml-1">pending</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScoreCell",
  props: {
    score: { type: Number, default: 0 },
    scoreA: { type: Number, default: 0 },
    scoreB: { type: Number, default: 0 },
    checkStatus: { type: String, default: "" },
    targetDate: { type: String, default: "" },
    hasFile: { type: Boolean, default: false },
    passThresholdA: { type: Number, default: 24 },
    passThresholdB: { type: Number, default: 36 },
    // === props ใหม่สำหรับรองรับ 2 เกณฑ์ ===
    criteriaVersion: { type: String, default: "OLD" }, // 'OLD' หรือ 'NEW'
    passStatus: { type: String, default: "" }, // 'pass', 'fail', 'pending'
    showLabel: { type: Boolean, default: true } // แสดง label OLD/NEW หรือไม่
  },
  computed: {
    hasScore() {
      if (this.criteriaVersion === "NEW") {
        return this.passStatus === "pass" || this.passStatus === "fail";
      }
      return this.score > 0;
    },
    scoreAClass() {
      if (this.scoreA < 1) return "score-na";
      return this.scoreA >= this.passThresholdA ? "score-pass" : "score-fail";
    },
    scoreBClass() {
      if (this.scoreB < 1) return "score-na";
      return this.scoreB >= this.passThresholdB ? "score-pass" : "score-fail";
    }
  }
};
</script>

<style scoped>
.score-cell {
  text-align: center;
  padding: 4px 0;
  min-width: 100px;
}
.score-pass {
  color: #4caf50;
  font-weight: bold;
  font-size: 14px;
}
.score-fail {
  color: #f44336;
  font-weight: bold;
  font-size: 14px;
}
.score-pending {
  color: #9e9e9e;
}
.score-na {
  color: #bdbdbd;
}
.score-detail {
  font-size: 11px;
  margin-top: 2px;
}
.criteria-label {
  font-size: 10px;
}
</style>